/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	var $ = jQuery;
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$(function () {
		var url = document.location.pathname;

		if (url.indexOf("/shop/") == 0 || url.indexOf("/product/") == 0 || url.indexOf("/events/") == 0 || url.indexOf("/event/") == 0 || url.indexOf("/cart/") == 0 || url.indexOf("/checkout/") == 0) {
			document.body.className = "secondNav";
			$(".saia-nav").addClass("bgPrimary");
			$('.footer').addClass("w-full absolute bottom-0");
			$('.content').addClass("min-h-screen relative mb-24");

		} else {
			$(document).scroll(function () {
				var $nav = $(".saia-nav");
				$nav.toggleClass('colorNav', $(this).scrollTop() > $nav.height());
			  });
		}

	  });

	  $(document).ready(function() {
		if ($('#wpadminbar')[0]) {
			$('.saia-nav').css('top', '32px');
			$('.secondNav').css('margin-top', '66px')
		}
	});
  
	  $('.hamburger-toggle').click(function(){
		$('.mobile-menu-drop').slideToggle(400);
		// $(this).siblings('.mobile-menu-drop').toggleClass('show-mobile-nav');
		$(this).children('.hamburgerMenu').toggleClass('menuIsOpened');
	  });

	  $( ".donateBtn" ).click(function() {
		$( ".wpedon_paypalbuttonimage" ).click();
	  });

}); 

